import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: string;
  brandImage: string;
  name: string;
  field_malay_title: string;
  field_mandarin_title: string;
  field_parent_category: string;
  status: boolean;
  published: boolean;
  createdAt: string;
  updatedAt: string;
}

// edit api call
const fetchBrandsDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanCMSApi.get(`/api/all-brands/${id}`);
  console.log("testing", response.data[0]);
  return response.data[0];
};

const useBrandsDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["brandsDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchBrandsDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useBrandsDocumentDetails };
